import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { ap_status } from '../../constants'
import { FONTS } from '../../../../constants'
import { formatNumber } from '../../../../function/math.js'

export const APSubItem = React.memo(({ data }) => {
  const _status = ap_status.find(s => s.value === data.status)
  const isBefore = data.delivery_date && moment(data.delivery_date).add(data.credit_term, 'days').isBefore(moment())

  return (
    <Root>
      <Col />
      <Col>
        <SubtitleText>Period</SubtitleText>
        <Number>{ data.period_no }</Number>
      </Col>
      <Col>
        <SubtitleText>Description</SubtitleText>
        <Text>{ data.description }</Text>
      </Col>
      <Col />
      <AmountCol>
        <SubtitleText>Amount</SubtitleText>
        <Number>฿ { formatNumber(data.cost) }</Number>
      </AmountCol>
      <Col>
        <SubtitleText>Delivery date</SubtitleText>
        <Number>{ data.delivery_date ? moment(data.delivery_date).format('DD/MM/YYYY') : '-' }</Number>
      </Col>
      <Col>
        <SubtitleText>Credit term</SubtitleText>
        <Number>{ data.credit_term || '-' } days</Number>
      </Col>
      <Col>
        <SubtitleText>Due Date</SubtitleText>
        <Number is_before={ isBefore }>
          { data.delivery_date ? moment(data.delivery_date).add(data.credit_term, 'days').format('DD/MM/YYYY') : '-' }
        </Number>
      </Col>
      <StatusCol>
        <StatusWrapper status={ _status }>
          <Dot status={ _status } />
          { _status ? _status.label : '' }
        </StatusWrapper>
      </StatusCol>
      <Col />
    </Root>
  )
})

const Root = styled.div`
  height: 54px;
  display: grid;
  grid-template-columns: 24px 100px minmax(auto, 250px) 1fr 1fr 100px 100px 100px 100px 150px;
  grid-gap: 24px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;
  background: #F1F1F1;
  border: 1px solid #EAEAEA;
  padding: 0 24px;

  @media (max-width: 1440px) {
    width: max-content;
    grid-template-columns: 24px 100px 200px 100px 100px 100px 100px 100px 100px 150px;
  }

  @media (max-width: 1024px) {
    width: max-content;
    grid-template-columns: 24px 100px 150px 100px 100px 100px 100px 100px 100px 150px;
  }

  :nth-child(1) {
    border: none;
  }

  #arrow {
    transform: ${p => (p.active ? 'rotate(90deg)' : 'rotate(0deg)')};
    transition: all 0.3s;
  }
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`

// const ProjCol = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   position: relative;

//   #tooltip-proj {
//     position: fixed;
//     max-width: 300px;
//     padding: 8px 12px;
//     background: #FFFFFF;
//     border: 1px solid #EAEAEA;
//     box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
//     border-radius: 4px;
//     color: #808080;
//     font-family: ${FONTS.GOTHAM};
//     font-size: ${FONTS.SMALL_SIZE};
//     transition: opacity 0s ease;
//     opacity: 0;
//     visibility: hidden;
//     white-space: normal;
//     z-index: 1;
//   }

//   #tooltip-proj::after {
//     position: absolute;
//     bottom: 100%;
//     left: 50%;
//   }

//   :hover {
//     #tooltip-proj {
//       transition: opacity 0s ease;
//       transition-delay: 1s;
//       opacity: 1;
//       visibility: visible;
//     }
//   }
// `

const AmountCol = styled(Col)`
  align-items: flex-end;
`

const StatusCol = styled.div`
  display: block;
  margin: auto 0;
`

const SubtitleText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const Text = styled(SubtitleText)`
  width: 90%;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1A1A17;
`


const Number = styled.span`
  font-family: ${FONTS.NOTOSANS};
  font-size: ${FONTS.SMALL_SIZE};
  color: ${p => (p.is_before ? '#D44B49' : '#1A1A17')};
`

const StatusWrapper = styled.div`
  min-width: 90px;
  width: fit-content;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.status ? p.status.bg : '')};
  color: ${p => (p.status ? p.status.color : '')};
  border-radius: 4px;
  padding: 0 10px;
`

const Dot = styled.div`
  width: 6px;
  height: 6px;
  background: ${p => (p.status ? p.status.color : '')};
  border-radius: 50%;
  margin-right: 6px;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ap-paying/ap-sub-item.js